import axios from "axios";
import { authHeaderJson } from "../auth-header.service";

const getListIncrements = () => {
    return axios.get(`/api/Pay/increment/list`, { headers: authHeaderJson() } )
};

const getIncrementById = (incrementId) => {
        return axios.get(`/api/Pay/increment/${incrementId}`, { headers: authHeaderJson() } );
};

const addIncrement = (increment) => {
    return axios.post(`/api/Pay/increment/add/`, increment, { headers: authHeaderJson() } );
}

const addIncrementList = (increments) => {
    return axios.post(`/api/Pay/increment/add/list`, increments, { headers: authHeaderJson() } );
}

const saveIncrementById = (incrementId, objIncrement) => {
    return axios.put(`/api/Pay/increment/${incrementId}`, objIncrement, { headers: authHeaderJson() });
};

const deleteIncrement = (incrementId) => {
    return axios.delete(`/api/Pay/increment/${incrementId}`, { headers: authHeaderJson() });
}

export {
    getListIncrements,
    getIncrementById,
    addIncrement,
    addIncrementList,
    saveIncrementById,
    deleteIncrement
}